import {StackedAreaChartIcon} from '@github-ui/custom-icons/StackedAreaChartIcon'
import {GraphBarHorizontalIcon, GraphBarVerticalIcon, GraphIcon, type Icon} from '@primer/octicons-react'

import type {MemexChartType} from '../../api/charts/contracts/api'

type LayoutOption = {label: string; type: MemexChartType; icon: Icon}

export const chartLayoutsMap: {
  [key in MemexChartType]: LayoutOption
} = {
  bar: {
    label: 'Bar',
    type: 'bar',
    icon: GraphBarVerticalIcon,
  },
  column: {
    label: 'Column',
    type: 'column',
    icon: GraphBarHorizontalIcon,
  },
  line: {
    label: 'Line',
    type: 'line',
    icon: GraphIcon,
  },
  'stacked-area': {
    label: 'Stacked area',
    type: 'stacked-area',
    icon: StackedAreaChartIcon,
  },
  'stacked-bar': {
    label: 'Stacked bar',
    type: 'stacked-bar',
    icon: GraphBarVerticalIcon,
  },
  'stacked-column': {
    label: 'Stacked column',
    type: 'stacked-column',
    icon: GraphBarHorizontalIcon,
  },
}
export const chartLayouts: Array<LayoutOption> = Object.values(chartLayoutsMap)
